import React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { BrandUtil, BrandThemeProvider, PageLayerProvider } from 'dw-us-ui';
import HomePage from './pages/HomePage';
import CaseBuilderPage from './pages/CaseBuilderPage';

const App = () => {
	const location = useLocation();
	const brand = BrandUtil.getBrand();
	const brandTag = BrandUtil.content(brand).tag.toLowerCase();
	const isCaseBuilder = location?.pathname?.includes('/casebuilder');

	return (
		<>
			<BrandThemeProvider brandTag={WEBPACK_BRAND_TAG}>
				<PageLayerProvider>
					<Switch>
						<Route
							render={() =>
								isCaseBuilder ? (
									<CaseBuilderPage brandTag={brandTag} />
								) : (
									<HomePage pathName={location?.pathname} />
								)
							}
						/>
					</Switch>
				</PageLayerProvider>
			</BrandThemeProvider>
		</>
	);
};

export default App;
